import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Mask a secret value showing only first and last 4 characters.
 * Returns '••••••••' if value is null, undefined, or too short.
 */
export function maskSecret(value: string | null | undefined): string {
  if (!value || value.length < 8) return '••••••••';
  return value.slice(0, 4) + '••••••••' + value.slice(-4);
}

// ---- Financial arithmetic (integer cents to avoid floating-point errors) ----

/** Convert euros to integer cents: 10.50 → 1050 */
export function toCents(amount: number): number {
  return Math.round(amount * 100);
}

/** Convert integer cents back to euros: 1050 → 10.50 */
export function fromCents(cents: number): number {
  return cents / 100;
}

/** Calculate a percentage discount in cents, rounded to nearest cent */
export function calcDiscountCents(priceInCents: number, percent: number): number {
  return Math.round(priceInCents * percent / 100);
}

/** Safe monetary multiplication: amount * quantity, in euros, rounded to cents */
export function monetaryMultiply(price: number, quantity: number): number {
  return fromCents(toCents(price) * quantity);
}
